import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import DashboardChart from './DashboardChart.js';
import {
    getData,
    getLabelXAxes
} from './DashboardChart.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    labels: getLabelXAxes,
    metricsData: getData
});

const DashboardChartComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            loading: state.dashboard.last.loading,
            parameters: state.dashboard.last.parameters
        };
    },
    function mapDispatchToProps(dispatch) {
        return {};
    }
)(DashboardChart);

export default DashboardChartComponent;
